import {
  allPass, ifElse, isNotEmpty, isNotNil, pipe, prop,
} from 'ramda';
import { nanoid } from 'nanoid/non-secure';

export const isNotNullAndNotEmpty = allPass([isNotEmpty, isNotNil]);
const isValuePropSet = pipe(prop('value'), isNotNullAndNotEmpty);
const getValue = prop('value');
export const setNanoIdOrKeepExisting = ifElse(isValuePropSet, getValue, () => nanoid());

export const arrayRange = (start, stop, step) => Array.from(
  { length: (stop - start) / step + 1 },
  (value, index) => start + index * step,
);

export const isIndividualPlan = (plan) => plan !== undefined && plan.requireCompany === false;
